import { Spinner } from '@/components/Spinner';
import { useLineGroupDetail } from '../hooks/useLineGroupDetail';
import ManageStoreLineGroupFormView from './ManageStoreLineGroupFormView';

const ManageStoreLineGroupForm = ({ clubid }: { clubid: string }) => {
  const { data, isLoading } = useLineGroupDetail(clubid);

  if (isLoading) return <Spinner />;
  if (!data) return null;

  const defaultValues = {
    lineGroupName: data.lineGroupName || '',
    existingImageSrc: data.lineQrImage?.path,
    image: '',
    lineGroupLink: data.lineGroupLink || '',
  };
  return <ManageStoreLineGroupFormView clubid={clubid} defaultValues={defaultValues} />;
};
export default ManageStoreLineGroupForm;
